<app-stepper
        [headerTitle]="'Estás gestionando tu seguro'"
        [headerLength]="mapSteps.length"
        [headerPositionActive]="positionActive"
        [mapTitle]="'GESTIONAR MIS SEGUROS'"
        [$mapSteps]="$mapStepChange"
>
</app-stepper>
<!--<app-footer></app-footer>-->
